import { pgTable, serial, integer, text, boolean, timestamp, uniqueIndex } from "drizzle-orm/pg-core";
import { appUsers, properties } from "./schema";

// No bank passwords, full account numbers, or Stripe client secrets are stored.
export const bankFeedSessions = pgTable("bank_feed_sessions", {
  id: text("id").primaryKey(),
  userId: integer("user_id").notNull().references(() => appUsers.id, { onDelete: "cascade" }),
  customerId: text("customer_id").notNull(),
  livemode: boolean("livemode").notNull(),
  createdAt: timestamp("created_at").defaultNow().notNull(),
});

export const bankFeedAccounts = pgTable("bank_feed_accounts", {
  id: serial("id").primaryKey(),
  userId: integer("user_id").notNull().references(() => appUsers.id, { onDelete: "cascade" }),
  stripeAccountId: text("stripe_account_id").notNull(),
  customerId: text("customer_id").notNull(),
  livemode: boolean("livemode").notNull(),
  institutionName: text("institution_name").notNull(),
  displayName: text("display_name").notNull(),
  last4: text("last4"),
  propertyId: integer("property_id").references(() => properties.id, { onDelete: "set null" }),
  status: text("status").notNull().default("pending"),
  lastRefresh: text("last_refresh"),
  lastSyncedAt: timestamp("last_synced_at"),
  lastCheckedAt: timestamp("last_checked_at"),
  syncError: text("sync_error"),
  createdAt: timestamp("created_at").defaultNow().notNull(),
}, table => ({
  stripeAccountUnique: uniqueIndex("bank_feed_account_stripe_unique").on(table.stripeAccountId, table.livemode),
}));

export type BankFeedAccount = typeof bankFeedAccounts.$inferSelect;
